import { Header, Footer } from "@/components/Chrome";

const LegalPage = ({ slug, kicker, title, intro, sections }) => (
  <div className="site-shell">
    <Header />
    <main data-testid={`${slug}-page`}>
      <section className="legal-hero">
        <p className="eyebrow" data-testid={`${slug}-kicker`}>{kicker}</p>
        <h1 data-testid={`${slug}-title`}>{title}</h1>
        <p className="legal-intro">{intro}</p>
      </section>
      <section className="legal-body">
        {sections.map((section, index) => (
          <div className="legal-block" key={section.heading} data-testid={`${slug}-section-${index}`}>
            <h2>{section.heading}</h2>
            {section.paragraphs?.map((text, i) => <p key={i}>{text}</p>)}
            {section.list && <ul>{section.list.map((item) => <li key={item}>{item}</li>)}</ul>}
          </div>
        ))}
        <p className="legal-updated" data-testid={`${slug}-updated`}>Last updated: July 2026 · DECODEAUTODEALS, United States</p>
      </section>
    </main>
    <Footer />
  </div>
);

export default LegalPage;
